import { PartialSerializer6novagrzu32x as PartialSerializer } from './PartialSerializer.mjs';
import { SerializerFactory1qv9hivitncuv as SerializerFactory } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      b2j(typeSerial0) {
        return new (PartialSerializer())(typeSerial0);
      }
      f1c(typeParamsSerializers) {
        return this.b2j(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var PartialClass;
function Partial() {
  if (PartialClass === VOID) {
    class $ {
      constructor(parts) {
        var tmp;
        if (parts === VOID) {
          // Inline function 'kotlin.collections.mutableMapOf' call
          tmp = LinkedHashMap().f6();
        } else {
          tmp = parts;
        }
        parts = tmp;
        this.i4r_1 = parts;
      }
      toString() {
        return 'Partial(parts=' + toString(this.i4r_1) + ')';
      }
      hashCode() {
        return hashCode(this.i4r_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Partial()))
          return false;
        if (!equals(this.i4r_1, other.i4r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Partial', Partial, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    PartialClass = $;
  }
  return PartialClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Partial as Partialk1npfnymwip2,
  Companion_instance as Companion_instance77mblgbd9v4t,
};
//endregion

//# sourceMappingURL=Partial.mjs.map
